import { useEffect, useState } from "react";
import { fetchMerchants, downloadMerchantsExcel } from "../Api/ViewMerchantMaster";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewMerchantMaster = () => {
  const [merchants, setMerchants] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadMerchants = async () => {
      try {
        const data = await fetchMerchants();
        setMerchants(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Merchants`);
      }
    };

    loadMerchants();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadMerchantsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Merchants_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Merchants data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>

        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Merchants</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || merchants.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {merchants.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Merchant ID</th>
                    <th>Merchant Code</th>
                    <th>Merchant Name</th>
                    <th>Merchant Type</th>
                    <th>Groups</th>
                    <th>State</th>
                    <th>Team Code</th>
                    <th>Contact Person</th>
                    <th>Address 1</th>
                    <th>Address 2</th>
                    <th>Mobile Number</th>
                    <th>Email</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {merchants.map((merchant, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{merchant.merchantID}</td>
                      <td>{merchant.merchantCode}</td>
                      <td>{merchant.merchantName}</td>
                      <td>{merchant.merchantType}</td>
                      <td>{merchant.groups}</td>
                      <td>{merchant.state}</td>
                      <td>{merchant.teamCode}</td>
                      <td>{merchant.contactPerson}</td>
                      <td>{merchant.address1}</td>
                      <td>{merchant.address2}</td>
                      <td>{merchant.mobileNumber}</td>
                      <td>{merchant.email}</td>
                      <td>{moment(merchant.createdAt).format('L')} at {moment(merchant.createdAt).format('LTS')}</td>
                      <td>{merchant.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No merchants found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewMerchantMaster;